import React, { useContext, useState } from "react";
import {
    Table,
    Thead,
    Tbody,
    Tr,
    Th,
    Td,
    TableContainer,
    Button,
    Box,
    IconButton,
    Heading,
    Flex,
    HStack,
    Spinner,
} from "@chakra-ui/react";
import { FaEdit, FaTrash, FaPlus } from "react-icons/fa";
import { AuthContext } from "../context/AuthContext";
import CreateSectionModal from "../components/sections/CreateSectionModal";
import UpdateSectionModal from "../components/sections/UpdateSectionModal";
import { stickyColHeaderProps, stickyColCellProps } from "../constants/tableStyles";

const SectionsPage = () => {
    const { sections, sectionsLoading, refetchSections } = useContext(AuthContext);
    const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
    const [isUpdateModalOpen, setIsUpdateModalOpen] = useState(false);
    const [selectedSection, setSelectedSection] = useState(null);

    const handleCreateSection = () => {
        refetchSections();
    };

    const handleUpdateSection = () => {
        refetchSections();
    };

    return (
        <Box
            as="main"
            pt={{ base: "24px", md: "20px" }}
            pl={{ base: "0px", md: "240px" }}
            pr={{ base: "0px", md: "30px" }}
            pb="20px"
            minH="100vh"
        >
            <Flex justify="space-between" align="center" mb={5} pl={4} pr={4}>
                <Heading size="lg" color="brand.700">Odjeljci</Heading>
                <Button bg="brand.600" color="white" boxShadow="soft" _hover={{ bg: "brand.700" }} onClick={() => setIsCreateModalOpen(true)}>
                    <FaPlus />
                </Button>
            </Flex>

            {sectionsLoading ? (
                <Flex justify="center" align="center" height="200px">
                    <Spinner size="xl" color="brand.600" />
                </Flex>
            ) : (
                <Box bg="white" borderRadius="xl" border="1px solid" borderColor="gray.100" boxShadow="card" p={3} mx={4}>
                <TableContainer overflowX="auto">
                    <Table variant="striped" colorScheme="gray" size="sm">
                        <Thead>
                            <Tr>
                                <Th {...stickyColHeaderProps}>#</Th>
                                <Th>Naziv</Th>
                                <Th>Akcije</Th>
                            </Tr>
                        </Thead>
                        <Tbody>
                            {sections.length > 0 ? (
                                sections.map((section, index) => (
                                    <Tr key={section.id} _hover={{ bg: "gray.50" }}>
                                        <Td {...stickyColCellProps(index % 2 === 0)}>{index + 1}</Td>
                                        <Td fontWeight="bold">{section.name}</Td>
                                        <Td>
                                            <HStack spacing={2}>
                                                <IconButton
                                                    aria-label="Ažuriraj odjeljak"
                                                    icon={<FaEdit />}
                                                    color="brand.700"
                                                    borderColor="brand.600"
                                                    borderWidth="1px"
                                                    variant="outline"
                                                    onClick={() => { setSelectedSection(section); setIsUpdateModalOpen(true); }}
                                                />
                                            </HStack>
                                        </Td>
                                    </Tr>
                                ))
                            ) : (
                                <Tr>
                                    <Td colSpan={3} textAlign="center">Nema unešenih odjeljaka.</Td>
                                </Tr>
                            )}
                        </Tbody>
                    </Table>
                </TableContainer>
                </Box>
            )}

            <CreateSectionModal isOpen={isCreateModalOpen} onClose={() => setIsCreateModalOpen(false)} handleCreateSection={handleCreateSection} />
            <UpdateSectionModal
                isOpen={isUpdateModalOpen}
                onClose={() => setIsUpdateModalOpen(false)}
                section={selectedSection || { name: "Unknown" }} 
                handleUpdateSection={handleUpdateSection}
            />
        </Box>
    );
};

export default SectionsPage;
